import type { CoreApiClient } from "../client";
import type {
  CreateUserRequestBody,
  PatchUserRequestBody,
  PatchUserResponseBody,
  PutUserNotificationRequestBody,
  PutUserNotificationResponseBody,
  User,
} from "../types";

export const createUserMutations = (api: CoreApiClient) => {
  const { request } = api;

  const create = async (buildingId: string, requestBody: CreateUserRequestBody): Promise<User> => {
    const { data } = await request("post", "/buildings/{buildingId}/users", {
      params: { path: { buildingId } },
      body: requestBody,
    });
    return data;
  };

  const update = async (userId: string, requestBody: PatchUserRequestBody): Promise<PatchUserResponseBody> => {
    const { data } = await request("patch", "/users/{userId}", {
      params: { path: { userId } },
      body: requestBody,
    });
    return data;
  };

  const updateNotification = async (
    buildingId: string,
    userId: string,
    requestBody: PutUserNotificationRequestBody,
  ): Promise<PutUserNotificationResponseBody> => {
    const { data } = await request("put", "/buildings/{buildingId}/users/{userId}/notifications", {
      params: { path: { buildingId, userId } },
      body: requestBody,
    });
    return data;
  };

  const deleteUser = async (buildingId: string, userId: string): Promise<void> => {
    const { data } = await request("delete", "/buildings/{buildingId}/users/{userId}", {
      params: { path: { buildingId, userId } },
    });
    return data;
  };

  return {
    create,
    update,
    updateNotification,
    delete: deleteUser,
  };
};
